export const REVIEWS_KEY = '@@reviews';
export const REVIEWS_TO_SHOW_ON_MOBILE = 10;
export const REVIEWS_TO_SHOW_ON_DESKTOP = 40;
export const REVIEWS_TO_SHOW_ON_DESKTOP_1Z = 50;
